<template>
  <BModal
    :active.sync="showModalConfirm"
    :on-cancel="cancelModal"
    has-modal-card
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
  >
    <div class="modal-card modal-confirm" style="width: auto">
      <section class="modal-card-body">
        <div class="container-header">
          <div class="container-header__cont-img">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/export.png" />
          </div>
          <div class="container-header__title">Exportar playlist</div>
          <div class="close-button" @click="clickClose">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" alt="close" width="48" />
          </div>
        </div>
        <div class="container-menu-export">
          <div class="container-menu-export__menu-row" v-if="!leyend">
            <div class="container-menu-export__menu-row__item-col">
              <div class="container-menu-export__menu-row__item-col__title">Cantidad:</div>
              <div class="container-menu-export__menu-row__item-col__box">
                <div class="container-menu-export__menu-row__item-col__box__row">
                  <div class="container-menu-export__menu-row__item-col__box__row__text-cont">
                    <div class="container-menu-export__menu-row__item-col__box__row__text-cont__title">
                      Un solo video
                    </div>
                    <div class="container-menu-export__menu-row__item-col__box__row__text-cont__subtitle">
                      (1 video)
                    </div>
                  </div>
                  <div class="container-menu-export__menu-row__item-col__box__row__radio-cont">
                    <BRadio
                      class="radio-switch-advanced-filter-activetime"
                      name="name"
                      v-model="typeval"
                      native-value="1"
                      type="is-info"
                    >
                    </BRadio>
                  </div>
                </div>
                <div class="container-menu-export__menu-row__item-col__box__sep"></div>
                <div class="container-menu-export__menu-row__item-col__box__row">
                  <div class="container-menu-export__menu-row__item-col__box__row__text-cont">
                    <div class="container-menu-export__menu-row__item-col__box__row__text-cont__title">
                      Videos individuales
                    </div>
                    <div class="container-menu-export__menu-row__item-col__box__row__text-cont__subtitle">
                      ({{ infomodal.num }} videos)
                    </div>
                  </div>
                  <div class="container-menu-export__menu-row__item-col__box__row__radio-cont">
                    <BRadio
                      class="radio-switch-advanced-filter-activetime"
                      name="name"
                      type="is-info"
                      native-value="0"
                      v-model="typeval"
                    >
                    </BRadio>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="container-menu-export__menu-row__item-col">
              <div class="container-menu-export__menu-row__item-col__title">Calidad:</div>
              <div class="container-menu-export__menu-row__item-col__box">
                <div class="container-menu-export__menu-row__item-col__box__row">
                  <div class="container-menu-export__menu-row__item-col__box__row__text-cont2">
                    Para WhatsApp
                  </div>
                  <div class="container-menu-export__menu-row__item-col__box__row__radio-cont">
                    <BRadio class="radio-switch-advanced-filter-activetime" name="name2" type="is-info"> </BRadio>
                  </div>
                </div>
                <div class="container-menu-export__menu-row__item-col__box__sep"></div>
                <div class="container-menu-export__menu-row__item-col__box__row">
                  <div class="container-menu-export__menu-row__item-col__box__row__text-cont2">
                    Máxima
                  </div>
                  <div class="container-menu-export__menu-row__item-col__box__row__radio-cont">
                    <BRadio class="radio-switch-advanced-filter-activetime" name="name2" type="is-info"> </BRadio>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="container-menu-export__leyend-cont" v-else>
            <div class="container-menu-export__leyend-cont__title">
              La descarga de tu playlist comenzar&aacute; <br />autom&aacute;ticamente en unos instantes.
            </div>
            <div class="container-menu-export__leyend-cont__note">
              <span class="container-menu-export__leyend-cont__note__bold">Nota:</span> este proceso puede demorar
              algunos segundos, puedes dar clic en "Cerrar" y continuar navegando en la plataforma. Es importante no
              refrescar, ni cerrar la página actual.
            </div>
          </div>
          <div class="value-button">
            <BButton
              class="container-menu-export__button"
              expanded
              type="is-primary"
              @click="clickExportVideo"
              :loading="loading"
            >
              Exportar Playlist
            </BButton>
          </div>
        </div>
      </section>
    </div>
  </BModal>
</template>

<script>
import { BModal } from 'buefy/dist/esm/modal';
import axios from 'axios';
import { mapState } from 'vuex';
export default {
  name: 'ExportVideo',
  components: {
    BModal,
  },
  props: {
    showModalConfirm: {
      type: Boolean,
      required: true,
    },
    infomodal: {
      type: [Object, Number],
      default: () => {},
    },
  },
  computed: {
    ...mapState('loginGeneral', ['user']),
  },
  data() {
    return {
      disabledConfirm: false,
      typeval: 1,
      loading: false,
      leyend: false,
      url: 'https://xqkvd3q4q2.execute-api.us-east-2.amazonaws.com/prod/exportPlaylist/',
    };
  },
  watch: {
    // showModalConfirm(newValue) {
    //   window.parent.postMessage({ message: 'modalShown', isShown: newValue }, '*');
    // },
  },
  methods: {
    async clickExportVideo() {
      this.loading = true;
      this.leyend = true;
      const getVideoDownload = await axios.get(this.url + this.user.id + '/' + this.infomodal.id + '/' + this.typeval);

      if (getVideoDownload.data.video_url != '') {
        this.$buefy.notification.open({
          message: 'Proceso de descarga comenzó con éxito!',
          type: 'is-success',
        });
        window.location.href = getVideoDownload.data.video_url;
        this.$emit('onCancelExport');
        this.typeval = 1;
        this.loading = false;
        this.leyend = false;
      } else {
        this.$buefy.notification.open({
          duration: 6000,
          message: 'El proceso para exportar no se completó correctamente, por favor vuelve a intentar!',
          type: 'is-danger',
        });
      }
    },
    clickClose() {
      this.$emit('onCancelExport');
      this.typeval = 1;
      this.loading = false;
      this.leyend = false;
    },

    cancelModal() {
      this.$emit('onCancelExport');
      this.typeval = 1;
      this.loading = false;
      this.leyend = false;
    },
  },
};
</script>
<style>
.container-menu-export .button.is-primary {
  border-radius: 10px;
  background-color: #cbee6b;
  height: 56px;
  width: 383px;
  font-size: 19px;
  font-family: 'Avenir-Demi';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  margin: 0 auto;
  line-height: 56px;
  letter-spacing: -0.38px;
  text-align: center;
  color: #132839;
  margin-top: 16px;
}
@media screen and (max-width: 768px) {
  .container-menu-export .button.is-primary {
    margin-top: 50px;
    width: 381px;
  }
}
@media screen and (max-width: 531px) {
  .container-menu-export .button.is-primary {
    width: 360px;
  }
}
@media screen and (max-width: 420px) {
  .container-menu-export .button.is-primary {
    width: 260px;
  }
}
</style>
<style lang="scss" scoped>
.container-menu-export {
  width: 531px;
  height: 230px;
  // background: red;
  @media screen and (max-width: 768px) {
    width: 380px;
    // height: 348px;
    margin-left: 6px;
  }
  @media screen and (max-width: 530px) {
    width: 360px;
    margin-left: 0px;
  }
  @media screen and (max-width: 420px) {
    width: 260px;
    margin-left: 0px;
  }
  &__leyend-cont {
    width: 100%;
    height: 150px;
    @media screen and (max-width: 768px) {
      height: 120px;
    }
    &__title {
      font-size: 21px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.19;
      letter-spacing: -0.42px;
      text-align: center;
      color: #132839;
      margin-top: 22px;
      font-family: 'Avenir-Bold';
      @media screen and (max-width: 420px) {
        font-size: 15px;
      }
    }
    &__note {
      font-family: 'Avenir-Regular';
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: -0.15px;
      text-align: center;
      margin-top: 16px;
      color: #7c8389;
      @media screen and (max-width: 420px) {
        font-size: 14px;
      }
      &__bold {
        font-family: 'Avenir-Medium';
      }
    }
  }
  &__button {
    border-radius: 10px;
    background-color: #cbee6b;
    height: 56px;
    width: 383px;
    font-size: 19px;
    font-family: 'Avenir-Demi';
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    margin: 0 auto;
    line-height: 56px;
    letter-spacing: -0.38px;
    text-align: center;
    color: #132839;
    margin-top: 16px;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
    @media screen and (max-width: 768px) {
      margin-top: 50px;
      width: 381px;
    }
    @media screen and (max-width: 531px) {
      width: 360px;
    }
    @media screen and (max-width: 420px) {
      width: 260px;
    }
  }
  &__menu-row {
    width: 100%;
    height: 150px;
    // background: green;
    display: inline-flex;
    justify-content: center;
    @media screen and (max-width: 768px) {
      display: inline-block;
      height: 120px;
    }
    &__item-col {
      width: 383px;
      height: 130px;
      // background: yellow;
      margin-left: 12px;
      margin-right: 12px;
      margin-top: 16px;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0px;
        margin-top: 16px;
      }
      &__title {
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
        // background: red;
        font-family: 'Roboto-Medium';
      }
      &__box {
        width: 100%;
        height: 110px;
        // background: purple;
        border-radius: 5px;
        border: solid 1px #cfd3dc;
        &__row {
          width: 100%;
          height: 54px;
          // background: #ee6b83;
          display: inline-flex;
          justify-content: space-between;
          &__text-cont2 {
            width: 75%;
            height: 54px;
            // background: #cbee6b;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 54px;
            letter-spacing: -0.26px;
            text-align: left;
            font-family: 'Avenir-Demi';
            color: #132839;
            margin-left: 5%;
          }
          &__text-cont {
            width: 75%;
            height: 54px;
            // background: cyan;
            margin-left: 5%;
            &__title {
              width: 100%;
              height: 27px;
              // background: red;
              font-size: 13px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 30px;
              letter-spacing: -0.26px;
              text-align: left;
              color: #132839;
              font-family: 'Avenir-Demi';
            }
            &__subtitle {
              width: 100%;
              height: 27px;
              // background: #ffffff;
              font-size: 13px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.15;
              letter-spacing: -0.26px;
              text-align: left;
              color: #505a62;
              font-family: 'Avenir-Demi-Medium';
            }
          }
          &__radio-cont {
            width: 20%;
            height: 54px;
            // background: rgb(112, 9, 112);
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            @media screen and (max-width: 768px) {
              width: 12%;
            }
          }
        }
        &__sep {
          width: 90%;
          margin: 0 auto;
          height: 1px;
          // background: #ee6b83;
          border-bottom: 1px dotted #cfd3dc;
        }
      }
    }
  }
}
.container-header {
  height: 46px;
  line-height: 46px;
  width: 531px;
  @media screen and (max-width: 768px) {
    width: 380px;
  }
  display: inline-flex;
  justify-content: left;
  border-bottom: 1px dotted #878e93;
  &__title {
    font-size: 18px;
    margin-left: 5.5px;
  }
  &__cont-img {
    img {
      margin-top: 3px;
    }
  }
}
.close-button {
  display: flex;
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 18px;
  top: 19px;
}
.modal-card-body {
  padding: 5px 5px 0px 5px !important;
}
.modal-confirm {
  width: 428px;
  margin: 0px 0px 0px 0px;
  padding: 0px 13px 25px;
  border-radius: 10px;
  box-shadow: 0 17px 32px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.question {
  width: 355px;
  height: 50px;
  margin: 20px 18px 32px 19px;
  font-family: 'Avenir-Medium';
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: -0.42px;
  text-align: center;
  color: #132839;
  grid-area: question;
  grid-column: 1 / 3;
  grid-row: 1 / 1;
}

.btn-container {
  display: grid;
  margin: 0 auto;
  width: fit-content;
}

.disabled-btn {
  background-color: #979797 !important;
  cursor: not-allowed !important;
}
.confirm-button {
  width: 179px;
}
.cancel-button {
  width: 179px;
}

.confirm-button,
.cancel-button {
  height: 56px;
  font-family: 'Circular-Std-Bold';
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  border-radius: 25px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.11px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

.left-button,
.right-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancel-button {
  border: solid 1px #979797;
  color: #494a4b;
}
.confirm-button {
  background-color: #ee6b83;
  color: #ffffff;
}

@media screen and (max-width: 768px) {
  .modal-confirm {
    width: 428px !important;
    margin: 0px 0px 0px 0px !important;
    padding: 0px 13px 25px !important;
    margin: 0 auto !important;
    text-align: center;
  }
}
@media screen and (max-width: 530px) {
  .container-header {
    height: 46px;
    line-height: 46px;
    width: 100%;
    display: inline-flex;
    justify-content: left;
    border-bottom: 1px dotted #878e93;
    &__title {
      font-size: 18px;
      margin-left: 5.5px;
    }
    &__cont-img {
      img {
        margin-top: 3px;
      }
    }
  }
  .modal-card-body {
    padding: 5px 5px 0px 5px !important;
  }
  .question {
    width: 296px !important;
    font-size: 19px !important;
  }
  .modal-confirm {
    width: 396px !important;
    margin: auto !important;
    margin: 0px 0px 0px 0px;
    padding: 0px 13px 25px;
  }

  .cancel-button {
    width: 155px;
    font-size: 20px;
    height: 43px;
  }
  .confirm-button {
    width: 155px;
    height: 43px;
    font-size: 20px;
  }
}
@media screen and (max-width: 420px) {
  .modal-confirm {
    width: 296px !important;
    margin: auto !important;
  }
  .question {
    width: 206px !important;
    height: 30px !important;
    font-size: 13px !important;
  }
  .cancel-button {
    width: 110px;
    height: 35px;
    font-size: 14px;
  }
  .confirm-button {
    width: 110px;
    height: 35px;
    font-size: 14px;
  }
}
</style>
